export class Float {
  static parse(value: string, separator: decimalSeparators): number {
    if (!value) return 0;

    const sanitized = value
      .replace(separator, 'separator')
      .replace(/[,. ]/g, '')
      .replace('separator', '.');

    const float = parseFloat(sanitized);
    return isNaN(float) ? 0 : float;
  }
}

export type decimalSeparators = '.' | ',';
